import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { Profile } from 'oidc-client';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { UserDetailService } from 'src/app/core/services/user-detail.service';

@Component({
  selector: 'app-profile-details-menu-view',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatMenuModule
  ],
  templateUrl: './profile-details-menu-view.component.html',
  styleUrls: ['./profile-details-menu-view.component.scss'],
})
export class ProfileDetailsMenuViewComponent implements OnInit {

  @Input() userProfile: Profile;

  @Output() closeNotification = new EventEmitter();

  @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;

  name = '';

  avatarColor: string = "#3a4a40";

  constructor(private userDetailService: UserDetailService,
              private authService: AuthService){}

  get isAdmin() {
    return this.userDetailService.getUserData().isAdminRole
  }

  ngOnInit(): void {
    this.name = sessionStorage.fullName;
  }

  onMenuOpened() {
    this.closeNotification.emit();
  }

  /** Kept for the layout shell, which closes this panel when others open. */
  closeAvatar() {
    this.menuTrigger?.closeMenu();
  }

  logOutUser() {
    this.authService.logout();
  }
}
